import { useTranslation } from "react-i18next";
import { Content } from "../../../commons/Template/Template";
import usePartners from "../../../Financing/usePartners";
import ImageContainer from "../../../commons/ImageContainer/ImageContainer";
import "./partners.css";
import { FormLoader } from "../../../commons/Form/Form";
import { useIndicators } from "../../Common/IndicatorsContext";

export default function Partners() {
  const { t } = useTranslation(["common", "treasury"]);
  document.title = t("treasury:partners.title");

  const { indicators, loading } = useIndicators();
  const allData = usePartners();

  const getValue = (partnerID, key) =>
    allData.find((partner) => partner.id === partnerID)?.[key];

  if (loading) return <FormLoader />;
  return (
    <Content>
      <PartnersGrid
        IDs={
          indicators.partners?.length > 0 &&
          indicators.partners.filter(
            (companyPartner) => !getValue(companyPartner, "duplicate"),
          )
        }
      />
    </Content>
  );
}

export function PartnersGrid({ IDs = null, className }) {
  const allData = usePartners();

  const getValue = (partnerID, key) =>
    allData.find((partner) => partner.id === partnerID)?.[key];

  return (
    <div className={["PartnersGrid", className].filter(Boolean).join(" ")}>
      {IDs &&
        IDs.map((companyPartner, index) => (
          <ImageContainer
            key={index}
            src={getValue(companyPartner, "logo")}
            alt={getValue(companyPartner, "id")}
            className="PartnersGrid-partner"
          />
        ))}
    </div>
  );
}
